import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { HandThumbDownIcon, HandThumbUpIcon } from '@heroicons/react/24/outline';
import InputComponent from '../../components/InputMC';
import ButtonSelectorMC from '../../components/ButtonSelectorMC';
import TitleDescriptionMC from '../../components/TitleDescriptionMC';
import ToggleSwitchMC from '../../components/ToggleSwitchMC';
import ReasonsForClosure from '../../modules/Funnels/ReasonsForClosure';

const ManageFunnelStepClosed = () => {
  const {
    getValues,
    setValue,
  } = useFormContext();

  const isNew = !getValues('id');
  const { t } = useTranslation('Funnels');

  const [closureReasonEnabled, setClosureReasonEnabled] = useState(getValues('reasons')?.length > 0);

  return (
    <div className="tw-wrapper">
      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stageClosed.fields.name.title')}
        description={isNew ? t('sidebar.createFromZero.stageClosed.fields.name.subtitle') : ''}
        className="tw-mb-2"
      />
      <InputComponent
        name="title"
        secondaryLabel={t('sidebar.createFromZero.stageClosed.fields.name.inputLabel')}
        placeholder={t('sidebar.createFromZero.stageClosed.fields.name.placeholder')}
        className="tw-resize-none"
        useFloatingAndNonFloatingLabel
      />

      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stageClosed.fields.qualification.title')}
        description={t('sidebar.createFromZero.stageClosed.fields.qualification.subtitle')}
        className="tw-mt-5"
      />
      <div className="tw-flex tw-gap-2 tw-mt-2 tw-mb-3">
        <ButtonSelectorMC
          text={t('sidebar.createFromZero.stageClosed.fields.qualification.won')}
          icon={HandThumbUpIcon}
          isSelected={getValues('type_step') === 'won'}
          onClick={() => setValue('type_step', 'won', { shouldDirty: true, shouldValidate: true })}
          className="tw-flex-1"
        />
        <ButtonSelectorMC
          text={t('sidebar.createFromZero.stageClosed.fields.qualification.lost')}
          icon={HandThumbDownIcon}
          isSelected={getValues('type_step') === 'lost'}
          onClick={() => setValue('type_step', 'lost', { shouldDirty: true, shouldValidate: true })}
          className="tw-flex-1"
        />
      </div>
      <ToggleSwitchMC
        isOn={closureReasonEnabled}
        handleToggle={() => {
          setClosureReasonEnabled(!closureReasonEnabled)
          const currentReasons = getValues('reasons') || [];

          if (closureReasonEnabled) {
            // Toggle is being turned OFF, mark all reasons as _destroy: true
            const destroyedReasons = currentReasons.map(r => ({ ...r, _destroy: true }));
            setValue('reasons', destroyedReasons, { shouldDirty: true, shouldValidate: true });
          } else {
            // Toggle is being turned ON, remove _destroy flag from all reasons
            const restoredReasons = currentReasons.map(r => {
              const { _destroy, ...rest } = r;
              return rest;
            });
            setValue('reasons', restoredReasons, { shouldDirty: true, shouldValidate: true });
          }
        }}
        label={t('sidebar.createFromZero.stageClosed.fields.reasonClosure.label')}
        labelClassName="!tw-font-semibold tw-font-sans"
      />
      <p className="tw-text-xs tw-py-2">
        {t('sidebar.createFromZero.stageClosed.fields.reasonClosure.description')}
      </p>

      <p className="tw-text-xs tw-pb-4 tw-italic tw-font-normal">
        {t('sidebar.createFromZero.stageClosed.fields.reasonClosure.advice')}
      </p>

      {closureReasonEnabled && (
        <ReasonsForClosure
          reasonsForClosure={getValues('reasons') || []}
          setReasonsForClosure={(reasons) => setValue('reasons', reasons || [], { shouldDirty: true, shouldValidate: true })}
        />
      )}
    </div>
  );
};

export default ManageFunnelStepClosed;
